module.exports = __webpack_public_path__ + "static/media/bpmeasurex-charger-1.b380f2e0.png";